<template>
    <div>
        <!-- Breadcrumb component -->
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb bg-white mb-0">
                <li class="breadcrumb-item" :class="{active: last === index}" v-for="(item, index) in items"
                    :key="index">
                    <template v-if="index === last">
                        {{ $t(item.name) }}
                    </template>

                    <router-link v-else :to="getLangUrl(item.url)">{{ $t(item.name) }}</router-link>
                </li>

            </ol>
            <div v-if="exceptionPageList && getUser.person.employeeInformation">
                <div v-if="getEmployeeAtWork.hasAtWork" @click="$bvModal.show('finish_work')"
                     class="btn-outline-danger my-btn">
                    {{ $t('atWork.closeNow') }}
                </div>
            </div>

            <div v-if="getUser.person.employeeInformation">
                <div v-if="getEmployeeAtWork.hasAtWork" @click="$bvModal.show('finish_work')"
                     class="relative left-28 ml-20 d-xl-none btn-outline-danger my-btn">
                    {{ $t('atWork.closeNow') }}
                </div>
            </div>
        </nav>

        <Modal
                :text="modalText"
                id="modal_show2"
        />

        <Modal
                text="atWork.wantFinishWorkBeforeTime"
                :on-ok-pressed="finishWork"
                :is-ok-only="false"
                ok-text="yes"
                id="finish_work"
        />

        <b-modal v-if="getUser.person.employeeInformation" id="finish_work" :title="$t('atWork.finishWork')" hide-footer
                 no-close-on-backdrop no-close-on-esc hide-header-close>

            <!-- Modal body -->
            <div class="modal-body">


                <div class="grid grid-cols-3 mt-1">
                    <div class="col-span-1 text-gray-500 text-xl mt-0.5">
                        {{ $t('atWork.yourJobTime') }}:
                    </div>
                    <div class="col-span-2 flex justify-content-around">
                        <div>
                            <span class="text-2xl font-bold text-fontColor">{{
                                    getUser.person.employeeInformation.startTime
                                }}</span>
                            <span class="text-gray-400">{{ $t('atWork.from') }}</span>
                        </div>
                        <div>
                            <span class="text-2xl font-bold text-fontColor">{{
                                    getUser.person.employeeInformation.endTime
                                }}</span>
                            <span class="text-gray-400">{{ $t('atWork.to') }}</span>
                        </div>
                    </div>
                </div>

                <div class="mt-3 text-2xl text-gray-500 font-bold">{{ $t('atWork.currentTime') }}: <span
                        class="font-mono">{{ time }}</span></div>

                <div class="mt-5 font-bold text-xl text-denyColor d-flex justify-content-center">
                    {{ $t('atWork.confirmFinishWork') }}
                </div>

            </div>

            <div class="border-b-0 border-dashed border-gray-200"></div>

            <div class="row mt-4">
                <div class="col-6 text-center">
                    <button
                            type="button"
                            @click="$bvModal.hide('finish_work')"
                            class="btn bg-denyColor px-3 py-1 hover:bg-hoverDenyColor rounded border-0 text-white font-bold w-36 h-10"
                    >
                        {{ $t('no') }}
                    </button>
                </div>
                <div class="col-6 text-center">
                    <button
                            type="button"
                            @click="finishWork"
                            class="btn bg-main px-3 py-1 hover:bg-hoverMain rounded border-0 text-white font-bold w-36 h-10"
                    >
                        {{ $t('yes') }}
                    </button>
                </div>
            </div>

        </b-modal>

        <b-modal v-if="getUser.person.employeeInformation" id="info" :title="$t('atWork.greeting')" hide-footer
                 no-close-on-backdrop no-close-on-esc hide-header-close>

            <!-- Modal body -->
            <div class="modal-body">
                <div>
                    <span class="text-gray-500 font-bold text-xl">{{ $t('atWork.today') }}: {{ getTodayDate() }}</span>
                </div>

                <div class="text-gray-500 text-xl mt-1">
                    {{ $t('atWork.yourJobTime') }}:
                </div>
                <div class="flex justify-content-between mt-1">
                    <div>
                        <span class="text-2xl font-bold text-fontColor">{{
                                getUser.person.employeeInformation.startTime
                            }}</span>
                        <span class="text-gray-400">{{ $t('atWork.from') }}</span>
                    </div>
                    <div>
                        <span class="text-2xl font-bold text-fontColor">{{
                                getUser.person.employeeInformation.endTime
                            }}</span>
                        <span class="text-gray-400">{{ $t('atWork.to') }}</span>
                    </div>
                </div>

                <div class="mt-3 text-2xl text-gray-500 font-bold">{{ $t('atWork.currentTime') }}: <span
                        class="font-mono">{{ time }}</span></div>
                <div v-if="hasAtTime" class="mt-3 text-green-700 text-xl font-bold">{{ $t('atWork.toJobTime') }}:
                    {{ msToReadableTime() }}
                </div>
                <div v-if="!hasAtTime && isFirstEntry" class="mt-3 text-red-700 text-xl font-bold">{{
                        $t('atWork.late')
                    }}: {{ msToReadableTime() }}
                </div>
                <div v-if="isSecondEntry || isThirdOrNextEntries">{{ $t('atWork.againEntry') }}</div>
            </div>

            <div v-if="!hasAtTime && isFirstEntry" class="mx-3 text-sm text-gray-500 font-bold">
                {{ $t('atWork.reasonLate') }} <span style="color: red">*</span>
                <textarea class="w-100" rows="4" v-model="modelForm.reason" style="border-radius: 5px"
                          :placeholder="$t('atWork.minSymbolAmount')"/>
            </div>

            <div v-if="isSecondEntry || isThirdOrNextEntries" class="mx-3 text-sm text-gray-500 font-bold">
                {{ $t('atWork.againEntryReason') }} <span style="color: red">*</span>
                <textarea class="w-100" rows="4" v-model="modelForm.reason" style="border-radius: 5px"
                          :placeholder="$t('atWork.minSymbolAmount')"/>
            </div>

            <div class="mt-4 flex justify-content-center">
                <button
                        :disabled="isDisabled"
                        type="button"
                        @click="beginWork"
                        style="background-color: green; color: #fff"
                        class="btn w-full mx-3"
                        data-dismiss="modal"
                >
                    {{ $t('atWork.startJob') }}
                </button>
            </div>

        </b-modal>

        <b-modal v-if="getUser.person.employeeInformation" id="over_limit" :title="$t('atWork.greeting')" hide-footer
                 no-close-on-backdrop no-close-on-esc hide-header-close>

            <!-- Modal body -->
            <div class="modal-body">
                <div>
                    <span class="text-gray-500 font-bold text-xl">{{ $t('atWork.today') }}: {{ getTodayDate() }}</span>
                </div>

                <div class="text-gray-500 text-xl mt-1">
                    {{ $t('atWork.yourJobTime') }}:
                </div>
                <div class="flex justify-content-between mt-1">
                    <div>
                        <span class="text-2xl font-bold text-fontColor">{{
                                getUser.person.employeeInformation.startTime
                            }}</span>
                        <span class="text-gray-400">{{ $t('atWork.from') }}</span>
                    </div>
                    <div>
                        <span class="text-2xl font-bold text-fontColor">{{
                                getUser.person.employeeInformation.endTime
                            }}</span>
                        <span class="text-gray-400">{{ $t('atWork.to') }}</span>
                    </div>
                </div>

                <div class="mt-3 text-2xl text-gray-500 font-bold">{{ $t('atWork.currentTime') }}: <span
                        class="font-mono">{{ time }}</span></div>


                <div class="mt-3 text-red-700 text-xl font-bold">
                    {{ $t('atWork.cantEntry') }}
                </div>
                <div class="mt-1 text-gray-500">
                    {{ $t('atWork.limit') }}
                </div>
            </div>

        </b-modal>

        <!-- Breadcrumb component -->
    </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import Modal from "@/components/html/Modal.vue";

export default {
    name: "Breadcrumb",
    components: {Modal},
    props: ['items'],
    data() {
        return {
            modalText: '',
            prevRoute: null,
            interval: null,
            time: null,
            diff: null,
            hasAtTime: false,
            optionsMonth: [
                {text: this.$t('statistics.month.Jan')},
                {text: this.$t('statistics.month.Feb')},
                {text: this.$t('statistics.month.Mar')},
                {text: this.$t('statistics.month.Apr')},
                {text: this.$t('statistics.month.May')},
                {text: this.$t('statistics.month.Jun')},
                {text: this.$t('statistics.month.Jul')},
                {text: this.$t('statistics.month.Aug')},
                {text: this.$t('statistics.month.Sep')},
                {text: this.$t('statistics.month.Oct')},
                {text: this.$t('statistics.month.Nov')},
                {text: this.$t('statistics.month.Dec')},
            ],
            modelForm: {
                startedAt: null,
                endedAt: null,
                hasAtWork: null,
                reason: '',
                lateTime: null
            }
        }
    },
    computed: {
        ...mapGetters(['getUser', 'getEmployeeAtWork', 'getEmployeeAtWorks']),
        exceptionPageList() {
            return this.$route.name === 'products/purchase'
                || this.$route.name === 'auto-order'
                || this.$route.name === 'auto-order/list'
                || this.$route.name === 'product/make-modify'
                || this.$route.name === 'product/modify/page'
                || this.$route.name === 'product/modified-products'
        },
        isDisabled() {
            return !this.hasAtTime ? this.modelForm.reason === '' || this.modelForm.reason.length < 10 : false
        },
        isFirstEntry() {
            return this.getEmployeeAtWorks.length === 1 && this.getEmployeeAtWork.startedAt === null && this.getEmployeeAtWork.endedAt === null
        },
        isSecondEntry() {
            return this.getEmployeeAtWorks.length === 1 && this.getEmployeeAtWork.endedAt !== null
        },
        isThirdOrNextEntries() {
            return this.getEmployeeAtWorks.length >= 2 && this.getEmployeeAtWork.endedAt !== null
        },
        last() {
            return this.items.length - 1
        }
    },
    methods: {
        ...mapActions(['putEmployeeAtWork', 'fetchEmployeeAtWork', 'fetchUser', 'pushEmployeeAtWork']),
        getLangUrl(url) {
            return this.$i18nHelper.getUrl(url)
        },
        isOverLimitEntry() {
            return this.getEmployeeAtWorks.length >= 3 && this.getEmployeeAtWork.endedAt !== null
        },
        beforeStartWork() {
            if (this.isOverLimitEntry()) {
                this.$bvModal.show('over_limit')

                return
            }

            let currentTime = new Date()
            let times = this.getUser.person.employeeInformation.startTime.split(':')
            let startTime = new Date(currentTime.getFullYear(), currentTime.getMonth(), currentTime.getDate(), +times[0], +times[1])
            let diff

            if (currentTime < startTime) {
                diff = startTime - currentTime
                this.hasAtTime = true
            } else {
                this.hasAtTime = false
                diff = currentTime - startTime
            }

            this.diff = diff

            if (this.isFirstEntry || this.isSecondEntry || this.isThirdOrNextEntries) {
                this.$bvModal.show('info')
            }
        },
        hasNeedShowModal() {
            let currentTime = new Date()
            let times = this.getEmployeeAtWork.employee.employeeInformation.endTime.split(':')
            let employeeEndTime = new Date(currentTime.getFullYear(), currentTime.getMonth(), currentTime.getDate(), +times[0], +times[1])

            return !(this.getEmployeeAtWork.startedAt !== null || currentTime > employeeEndTime)
        },
        msToReadableTime() {
            const second = 1000;
            const minute = second * 60;
            const hour = minute * 60;

            let hours = Math.floor(this.diff / hour % 24);
            let minutes = Math.floor(this.diff / minute % 60);

            if (hours === 0) {
                return minutes + ' ' + this.$t('atWork.minute')
            }

            return hours + ' ' + this.$t('atWork.hour') + ' ' + minutes + ' ' + this.$t('atWork.minute')
        },
        getTodayDate() {
            let today = new Date()

            return today.getDate() + '-' + this.optionsMonth[today.getMonth()].text
        },
        getEmployeeWorkTime() {
            if (this.getUser.person.employeeInformation) {
                return this.getUser.person.employeeInformation.startTime + '-' + this.getUser.person.employeeInformation.endTime
            }
        },
        realtimeClock() {
            this.interval = setInterval(() => {
                this.time = Intl.DateTimeFormat(navigator.language, {
                    hour12: false,
                    hour: '2-digit',
                    minute: '2-digit',
                    second: '2-digit',
                }).format()
            }, 1000)
        },
        beginWork() {
            if (this.isFirstEntry) {
                this.updateAtWork()
            } else {
                this.createAtWork()
            }
        },
        updateAtWork() {
            this.$root.showOverlay = true

            this.modelForm.startedAt = this.getCurrentTime()
            this.modelForm.hasAtWork = true
            this.modelForm.id = this.getEmployeeAtWork.id

            if (!this.hasAtTime) {
                this.modelForm.lateTime = this.calcLateTime()
            }

            this
                .putEmployeeAtWork(this.modelForm)
                .then(() => {
                    this.$root.showOverlay = false
                    this.$bvModal.hide('info')
                })
                .catch((reason) => {
                    this.$root.showOverlay = false
                    this.modalText = reason
                    this.$bvModal.show('modal_show2')
                })
        },
        createAtWork() {
            this.$root.showOverlay = true

            let data = {}
            data.company = this.getUser.person.company['@id']
            data.employee = this.getUser.person['@id']
            data.startedAt = this.getCurrentTime()
            data.hasAtWork = true
            data.reason = this.modelForm.reason

            if (!this.hasAtTime) {
                data.lateTime = this.calcLateTime()
            }

            this
                .pushEmployeeAtWork(data)
                .then(() => {
                    this.$root.showOverlay = false
                    this.$bvModal.hide('info')
                })
                .catch((reason) => {
                    this.$root.showOverlay = false
                    this.modalText = reason
                    this.$bvModal.show('modal_show2')
                })
        },
        calcLateTime() {
            return Math.floor(this.diff / 1000 / 60);
        },
        finishWork() {
            this.$root.showOverlay = true

            let data = {}
            data.id = this.getEmployeeAtWork.id
            data.endedAt = this.getCurrentTime()
            data.hasAtWork = false

            this
                .putEmployeeAtWork(data)
                .then(() => {
                    this.$root.showOverlay = false

                    this.$i18nHelper.toUrl('logout');
                })
                .catch((reason) => {
                    this.$root.showOverlay = false
                    this.modalText = reason
                    this.$bvModal.show('modal_show2')
                })
        },
        getCurrentTime() {
            let d = new Date()

            return this.addZero(d.getHours()) + ':' + this.addZero(d.getMinutes())
        },
        addZero(val) {
            return val < 10 ? '0' + val : val;
        }
    },
    created() {
        this.realtimeClock()
    },
    mounted() {
        if (this.getUser.person.employeeInformation !== null) {
            this
                .fetchEmployeeAtWork()
                    .then(() => {
                        this.beforeStartWork()
                    })
        }
    }
}
</script>

<style scoped>

.my-btn {
    position: absolute;
    top: 5px;
    right: 20px;
    height: 38px;
    width: 150px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    cursor: pointer;
    background-color: #dfe2e5;
    color: #6F42C1;
    font-weight: 600;
}

.my-btn:hover {
    background-color: red;
    color: white;
}
</style>
